import EfProductNaver, { EfProductNaverItemProps } from '@elem/ui/ef-product-naver';
import { useLang } from '@/i18n';
import { useMemo } from 'react';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';

export default function NavProduct() {
    const dispatch = useProductDispatch();
    const { t } = useLang('delta3series');
    const { productPageData } = useProductStore();
    const { productSeries = [] } = productPageData;

    const tabs: EfProductNaverItemProps[] = [
        {
            key: 'Product',
            text: t('nav_tab1'),
        },
        {
            key: 'Support',
            text: t('nav_tab2'),
        },
        {
            key: 'Specs',
            text: t('nav_tab3'),
        },
    ];

    const buyItem: EfProductNaverItemProps = {
        key: 'Buy',
        text: t('nav_buy') || 'Buy Now',
        url: productSeries[0]?.buyLink,
    };

    const itemCallback = (item: any) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.key,
        });
        setTimeout(() => {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth',
            });
        }, 100);
    };

    const buyNowGtm = useMemo(
        () => ({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: 'DELTA 3',
            position: 'Product Detail_DELTA 3',
        }),
        []
    );

    return (
        <>
            <GetProductData />
            <EfProductNaver
                title="DELTA 3"
                tabs={tabs}
                hideBuy={true}
                buyNowGtm={buyNowGtm}
                // buyItem={buyItem}
                callbackTab={itemCallback}
            />
        </>
    );
}
